@use '@css/variables';


.tabs {

  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;

  .image {
    flex-basis: 33%;

  }

  .content {
    flex-basis: 66%;
  }
}


@media only screen and (min-width: variables.$sm-breakpoint) {
  .tabs {

    flex-direction: row;
  }
}


.orderedList
{
  padding-left: 1.75em;
  list-style-type: decimal;
}


.unorderedList
{
  padding-left: 1.75em;
  list-style-type: disc;
}
